import { useEffect } from 'react';
import { Flex, Group, Stack, Image, Box, Anchor } from '@mantine/core';

import { Trans, useTranslation } from 'react-i18next';
import { Section, SectionText, SectionTitle } from 'components';
import { AppConstants } from '../../../constants';
import classes from './index.module.css';
import { APP_STORE_LINK, GOOGLE_PLAY_LINK } from 'constants/app';
import { trackCustomEvent, trackEvent } from 'utils/metaPixel';

const { MOBILE_APP_IMG_DE, MOBILE_APP_IMG_SR, MOBILE_APP_IMG_EN, GOOGLE_PLAY_IMG, APP_STORE_IMG } = AppConstants;

interface IRequestFinalScreen {
  additionalText?: string,
  description: string,
  title: string,
}

const RequestFinalScreen = ({ additionalText, description, title }: IRequestFinalScreen) => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;
  
  const mobileAppImages: Record<string, string> = {
      sr: MOBILE_APP_IMG_SR,
      de: MOBILE_APP_IMG_DE,
      en: MOBILE_APP_IMG_EN,
    };

  const mobileAppImage = mobileAppImages[currentLang] || MOBILE_APP_IMG_DE;

  useEffect(function() {
    trackCustomEvent("ApplicationProgress");
    trackEvent("Lead");
  }, []);

  return (
    <Section>
      <Flex justify='space-between' direction={{ base: 'column', sm: 'row' }}>
        <Stack className={classes.info} maw={900}>
          <SectionTitle title={title} variant='dark' />
          <SectionText text={description} variant='dark' />
          {additionalText ? 
            <SectionText variant='dark'>
              <Trans
                i18nKey={additionalText}
                components={{
                  highlight: <span className={classes.accent} />,
                }}
              />
            </SectionText>
          : undefined}
          <Group my={30}>
            <Anchor href={GOOGLE_PLAY_LINK} target='_blank'>
              <Image className={classes.logos} src={GOOGLE_PLAY_IMG} />
            </Anchor>
            <Anchor href={APP_STORE_LINK} target='_blank'>
              <Image className={classes.logos} src={APP_STORE_IMG} />
            </Anchor>
          </Group>
        </Stack>
        <Box className={classes.image}>
          <Image src={mobileAppImage} />
        </Box>
      </Flex>
    </Section>
  )
}

export default RequestFinalScreen;